import { useTranslation } from 'react-i18next'
import withTranslateProvider from 'src/hoc/with-translate-provider'
import HeadMetaTags from '~/components/HeadMetaTags'
import PrivacyPolicyContainer from '~/features/privacy-policy'
import en_request_demo from '../../public/locales/en/request-demo.json'
import jp_request_demo from '../../public/locales/ja/request-demo.json'

const PrivacyPolicyPage = () => {
  const { t } = useTranslation()

  return (
    <>
      <HeadMetaTags
        title={t('meta:privacy_policy:meta_title')}
        description={t('meta:privacy_policy:meta_description')}
      />
      <PrivacyPolicyContainer />
    </>
  )
}

export default withTranslateProvider(PrivacyPolicyPage, {
  en: { request_demo: en_request_demo },
  ja: { request_demo: jp_request_demo }
})
